export const PATH_LOGIN = '/patient/login';
export const PATH_ONE_PLUS_AUTHENTICATION = '/patient/login/enterCode';
export const PATH_ONBOARDING_TUTORIAL = '/patient/onboardingTutorial';
export const PATH_HOME = '/patient/home';
export const PATH_WELLNESS_SURVEY_HOME = '/patient/home/wellnessSurvey';
export const PATH_FREE_TEXT_SURVEY_HOME = '/patient/home/freeTextSurvey';
export const PATH_WELLNESS_SURVEY_QUESTION = '/patient/wellnessSurvey/questions';
export const PATH_LAB_REQUISITION = '/patient/home/labRequisition';
export const PATH_DOCTOR_NOTE = '/patient/home/doctorNote';
export const PATH_NOTES = '/patient/notes';
export const PATH_LABS_PSA = '/patient/labs/psa';
export const PATH_LABS_HCG = '/patient/labs/hcg';
export const PATH_LABS_AFP = '/patient/labs/afp';
export const PATH_LABS_LDH = '/patient/labs/ldh';
export const PATH_LABS_FSH = '/patient/labs/fsh';
export const PATH_LABS_LH = '/patient/labs/lh';
export const PATH_LABS = '/patient/labs';
export const PATH_SURVEYS = '/patient/surveys';
export const PATH_PROFILE = '/patient/profile';
export const PATH_LABS_TESTOSTERONE = '/patient/labs/testosterone';
export const PATH_SURVEY_RESPONSES = '/patient/surveys/responses/';
export const PATH_RESET_LINK_EXPIRED = '/patient/resetLinkExpired';
export const PATH_PROFILE_ACCOUNT_DETAILS = '/patient/profile/accountDetails';
export const PATH_PROFILE_PASSWORD = '/patient/profile/password';
export const PATH_PROFILE_SECURITY_QUESTIONS = '/patient/profile/securityQuestions';
export const PATH_PROFILE_PRIVACY_POLICY = '/patient/profile/privacyPolicy';
export const PATH_HELP_CENTRE = '/patient/profile/helpCentre';
export const PATH_TERMS_AND_CONDITIONS = '/patient/profile/termsAndConditions';
export const PATH_CHAT = '/patient/chat';
export const PATH_CALENDAR = '/patient/calendar';
export const PATH_CALENDAR_TUTORIAL = '/patient/calendarTutorial';
export const PATH_CALENDAR_INFO = '/patient/calendar/testInfo';
export const PATH_IMAGING = '/patient/home/imaging';
export const PATH_REQUEST_PASSWORD_RESET = '/patient/login/requestPasswordReset';
